import { XMarkIcon } from '@heroicons/react/16/solid';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { Dispatch, SetStateAction } from 'react';
import { Button, Tooltip } from 'react-daisyui';
import { MediaType } from '../../../../../Chat.enum';
import { useChatContext } from '../../../../../Chat.hook';
import { tAttachment } from '../../../../../Chat.types';
import AudioContent from '../../../../MessageContainer/components/EventBubble/components/MessageBubble/components/AudioContent/AudioContent.component';
import { useMessageBarContext } from '../../../MessageBar.hook';

export default function Attachment(props: {
  file: tAttachment;
  index: number;
  setNewAttachments: Dispatch<SetStateAction<tAttachment[] | undefined>>;
  handleOnClick: () => void;
}) {
  const { draftMessages, setDraftMessages, setChatAttachments } =
    useMessageBarContext();
  const { selectedChat } = useChatContext();
  const { file, index, setNewAttachments, handleOnClick } = props;
  const getFileExtension = file.mimeType?.split('/')?.[1];
  const fileExtension =
    getFileExtension === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ? 'xlsx'
      : getFileExtension;

  function removeAttachment(index: number) {
    const currentDraft = draftMessages?.findIndex(
      (draftMessage) => draftMessage.leadId === selectedChat?.leadId,
    );

    if (currentDraft !== undefined && currentDraft > -1) {
      draftMessages?.[currentDraft].attachments?.splice(index, 1);
    }

    setDraftMessages(draftMessages);

    setNewAttachments((prevValue) => {
      if (!prevValue) return prevValue;

      const attachmentsToUpdate = [...prevValue];
      attachmentsToUpdate.splice(index, 1);

      return attachmentsToUpdate;
    });

    setChatAttachments((prevValue) => {
      if (!prevValue) return prevValue;

      const attachmentsToUpdate = [...prevValue];
      attachmentsToUpdate.splice(index, 1);

      return attachmentsToUpdate;
    });
  }

  const MediaIcon = () =>
    ((file.mediaType === MediaType.IMAGE ||
      file.mediaType === MediaType.STICKER) && (
      <img
        src={file.url || undefined}
        className="w-10 aspect-square object-cover"
      />
    )) ||
    (file.mediaType === MediaType.VIDEO && (
      <video
        src={file.url || undefined}
        className="w-10 aspect-square object-cover"
      />
    )) ||
    (file.mediaType === MediaType.AUDIO && (
      <AudioContent attachment={file} />
    )) ||
    (file.mediaType === MediaType.DOCUMENT && (
      <DocumentTextIcon className="w-10 text-primary" />
    )) ||
    null;

  return (
    <div
      className={`relative flex items-center gap-2 border rounded-xl p-2 cursor-pointer ${file.mediaType === MediaType.AUDIO ? 'w-fit' : 'w-52 min-w-52'}`}
      onClick={handleOnClick}
    >
      <MediaIcon />
      {file.mediaType !== MediaType.AUDIO ? (
        <div>
          <Tooltip message={file.filename || ''} position="bottom">
            <p className="font-bold font-sans truncate max-w-36">
              {file.filename}
            </p>
          </Tooltip>
          <p className="font-bold font-sans truncate max-w-36">
            {fileExtension || ''}
          </p>
        </div>
      ) : null}
      <Button shape="circle" size="xs" className="absolute -right-3 -top-3">
        <XMarkIcon
          onClick={(e) => {
            e.stopPropagation();
            removeAttachment(index);
          }}
          className="w-4"
        />
      </Button>
    </div>
  );
}
